import React from "react";
import { connect } from "react-redux";
import Loader from "Components/loader/Loader";
import PropTypes from "prop-types";
import * as resActions from "../modules/resources";
import Tabs from "Components/tabs/Tabs";
import OwnershipCheckDNS from "Components/ownershipCheck/OwnershipCheckDNS";
import OwnershipCheckEmail from "Components/ownershipCheck/OwnershipCheckEmail";
import OwnershipCheckHTML from "Components/ownershipCheck/OwnershipCheckHTML.jsx";
import * as ocActions from "../modules/ownershipcheck";
import { withRouter } from "react-router-dom";
import qs from "query-string";
import t from "Utils/translation";
import cx from "classnames";
import s from "./ownershipCheck.scss";

const ContextTypes = {
  isLoggedUserTrial: PropTypes.func,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
};

class OwnershipCheckScreen extends React.Component {
  constructor(props, context) {
    super(props, context);
    let resourcesType = "domain";
    if (this.props.location.pathname.match(/aliases/)) {
      resourcesType = "aliasDomain";
    }

    this.resetAndGoBack = this.resetAndGoBack.bind(this);

    let returnUrl;
    if (resourcesType === "aliasDomain") {
      returnUrl = `/domains/${props.match.params.domainCode}/aliases`;
      if (context.isLoggedUserAdmin()) {
        returnUrl = `/customers/${props.domain.customer_code}${returnUrl}`;
      }
    } else {
      returnUrl = "/domains";
    }

    this.state = {
      resourcesType,
      returnUrl,
    };
  }

  UNSAFE_componentWillMount() {
    if (this.state.resourcesType === "aliasDomain") {
      this.props.getAliasDomain(this.props.match.params.aliasDomainCode);
    }

    this.props.getDomain();
  }

  componentWillUnmount() {
    this.props.resetOwnershipcheckStatus();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let resource, isResourceLoading;
    if (this.state.resourcesType === "aliasDomain") {
      const { aliasDomain, isAliasDomainLoading } = nextProps;
      resource = aliasDomain;
      isResourceLoading = isAliasDomainLoading;
    } else {
      const { domain, isDomainLoading } = nextProps;
      resource = domain;
      isResourceLoading = isDomainLoading;
    }
    const isResourceStateOwnershipCheck = resource ? resource.status === "ownership_check" : false;
    if (!isResourceStateOwnershipCheck && !isResourceLoading) {
      this.props.history.push(this.state.returnUrl);
    }
  }

  resetAndGoBack() {
    this.props.history.push(this.state.returnUrl);
  }

  renderResellerTabs(resource, isVerifing, isVerifingEmail, emailChosen, returnUrl, canSkip, generateFile, verifyFile) {
    return (
      <Tabs
        className={s.tabs}
        {...this.props}
        tabs={{
          [t("tab.verify.dns")]: (
            <OwnershipCheckDNS
              {...this.props.ownershipCheck.dns}
              possessionARecord={resource.possession_a_record}
              domainName={resource.name}
              updatedAt={resource.updated_at}
              domainCode={resource.code}
              verifyDNS={this.props.verifyDNS}
              skipOwnershipCheck={this.props.skipOwnershipCheck}
              isVerifing={isVerifing}
              checkDNSVerificationStatus={this.props.checkDNSVerificationStatus}
              isloggedUserWholesale={canSkip}
              refreshAliasDomain={this.props.refreshAliasDomain}
              refreshDomain={this.props.refreshDomain}
              isTeamMemberOfAWholesale={this.props.isTeamMemberOfAWholesale}
              isLoggedUserAdmin={this.context.isLoggedUserAdmin()}
              returnUrl={returnUrl}
              isAlias={this.state.resourcesType === "aliasDomain"}
              aliasDomainCode={this.props.match.params.aliasDomainCode}
              resetAndGoBack={this.resetAndGoBack}
            />
          ),
          [t("tab.verify.email")]: (
            <OwnershipCheckEmail
              {...this.props.ownershipCheck.email}
              domainName={resource.name}
              domainCode={this.props.match.params.domainCode}
              sendVerificationEmail={this.props.sendVerificationEmail}
              isCodeSent={isVerifingEmail}
              verifyCode={this.props.verifyCode}
              emailChosen={emailChosen}
              resetDomainEmailVerificationStatusDetail={this.props.resetDomainEmailVerificationStatusDetail}
              resetEmailVerification={this.props.resetEmailVerification}
              returnUrl={returnUrl}
              isAlias={this.state.resourcesType === "aliasDomain"}
              aliasDomainCode={this.props.match.params.aliasDomainCode}
              resetAndGoBack={this.resetAndGoBack}
            />
          ),
          [t("tab.verify.html")]: (
            <OwnershipCheckHTML
              {...this.props.ownershipCheck.html}
              domainName={resource.name}
              domainCode={this.props.match.params.domainCode}
              aliasDomainCode={this.props.match.params.aliasDomainCode}
              generateFile={generateFile}
              verifyFile={verifyFile}
              isAlias={this.state.resourcesType === "aliasDomain"}
              resetOwnershipcheckStatus={this.props.resetOwnershipcheckStatus}
              resetAndGoBack={this.resetAndGoBack}
            />
          ),
        }}
      />
    );
  }

  renderNoTabs(resource, isVerifing, isloggedUserWholesale, isTeamMemberOfAWholesale, returnUrl) {
    return (
      <OwnershipCheckDNS
        {...this.props.ownershipCheck.dns}
        possessionARecord={resource.possession_a_record}
        domainName={resource.name}
        updatedAt={resource.updated_at}
        domainCode={this.props.match.params.domainCode}
        aliasDomainCode={this.props.match.params.aliasDomainCode}
        verifyDNS={this.props.verifyDNS}
        skipOwnershipCheck={this.props.skipOwnershipCheck}
        isVerifing={isVerifing}
        returnUrl={returnUrl}
        checkDNSVerificationStatus={this.props.checkDNSVerificationStatus}
        isloggedUserWholesale={isloggedUserWholesale}
        isTeamMemberOfAWholesale={isTeamMemberOfAWholesale}
        refreshAliasDomain={this.props.refreshAliasDomain}
        refreshDomain={this.props.refreshDomain}
        isLoggedUserAdmin={this.context.isLoggedUserAdmin()}
        isAlias={this.state.resourcesType === "aliasDomain"}
        resetAndGoBack={this.resetAndGoBack}
      />
    );
  }

  render() {
    let resource, isResourceLoading;
    const { returnUrl } = this.state;
    if (this.state.resourcesType === "aliasDomain") {
      const { aliasDomain, isAliasDomainLoading } = this.props;
      resource = aliasDomain;
      isResourceLoading = isAliasDomainLoading;
    } else {
      const { domain, isDomainLoading } = this.props;
      resource = domain;
      isResourceLoading = isDomainLoading;
    }

    const loggedUser = this.context.getLoggedUser();
    const isTeamMember = loggedUser.type === "TeamMember";
    const isloggedUserReseller = loggedUser.is_reseller;
    const isloggedUserWholesale = loggedUser.is_wholesale;
    const isTeamMemberOfAReseller = loggedUser.is_customer_reseller && isTeamMember;
    const isTeamMemberOfAWholesale = loggedUser.is_customer_wholesale && isTeamMember;

    if (isResourceLoading) return <Loader {...this.props} />;

    const isVerifing = this.props.ownershipCheck.dns.isVerifing || resource.status_detail === "verifing";
    const isVerifingEmail = this.props.ownershipCheck.email.isCodeSent || resource.status_detail === "email_sent";
    const emailChosen = this.props.ownershipCheck.email.emailChosen || resource.ownership_verification_email_address;

    const canSkip = isloggedUserWholesale || isTeamMemberOfAWholesale;
    let content;
    if (isloggedUserReseller || isTeamMemberOfAReseller || canSkip) {
      content = this.renderResellerTabs(
        resource,
        isVerifing,
        isVerifingEmail,
        emailChosen,
        returnUrl,
        canSkip,
        this.props.generateFile,
        this.props.verifyFile
      );
    } else {
      content = this.renderNoTabs(resource, isVerifing, isloggedUserWholesale, isTeamMemberOfAWholesale, returnUrl);
    }

    return (
      <div className={s.ownershipCheckPage}>
        <div className={s.ownershipCheck}>
          <div className={cx(s.title, "sectionTitle")}>{t("ownershipcheck.title")}</div>
          <div className={s.content}> {content} </div>
        </div>
      </div>
    );
  }
}
OwnershipCheckScreen.contextTypes = ContextTypes;
const mapStateToProps = (state) => ({
  domain: resActions.getData("domain.data", state)[0],
  aliasDomain: resActions.getData("aliasDomain.data", state)[0],
  isAliasDomainLoading: resActions.isResourceLoading("aliasDomain", state),
  isDomainLoading: resActions.isResourceLoading("domain", state),
  ownershipCheck: state.ownershipCheck,
});
const mapDispatchToProps = (dispatch, props) => {
  const domainCode = props.match.params.domainCode;
  return {
    getDomain: () => dispatch(resActions.callApi("getDomain", "domain", domainCode)),
    getAliasDomain: (code) => dispatch(resActions.callApi("getAliasDomain", "aliasDomain", domainCode, code)),
    refreshDomain: () => dispatch(resActions.callApi("refreshDomain", "domain", domainCode)),
    refreshAliasDomain: (code) => dispatch(resActions.callApi("refreshAliasDomain", "aliasDomain", domainCode, code)),
    sendVerificationEmail: (code, formValues, aliasDomainCode) =>
      dispatch(ocActions.sendVerificationEmail(code, formValues, aliasDomainCode)),
    verifyCode: (code, formValues, aliasDomainCode) =>
      dispatch(ocActions.verifyCode(code, formValues, aliasDomainCode)),
    verifyDNS: (aliasDomainCode) => dispatch(ocActions.verifyDNSRecord(domainCode, aliasDomainCode)),
    checkDNSVerificationStatus: (aliasCode) => dispatch(ocActions.checkDNSVerificationStatus(domainCode, aliasCode)),
    resetOwnershipcheckStatus: () => dispatch(ocActions.resetState()),
    skipOwnershipCheck: (aliasDomainCode) => dispatch(ocActions.skipOwnershipCheck(domainCode, aliasDomainCode)),
    resetEmailVerification: (domainCode) => dispatch(ocActions.resetEmailVerification(domainCode)),
    resetDomainEmailVerificationStatusDetail: (domainCode) =>
      dispatch(
        resActions.changeAttribute(null, {
          resourcesType: "domain",
          resourceCode: domainCode,
          resourceAttribute: "status_detail",
        })
      ),
    generateFile: (domainCode, aliasDomainCode = false) => {
      return dispatch(ocActions.generateFile(domainCode, aliasDomainCode));
    },
    verifyFile: (domainCode, aliasDomainCode = false) => {
      return dispatch(ocActions.verifyFile(domainCode, aliasDomainCode));
    },
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OwnershipCheckScreen));
